import { Phone, ArrowRight, CheckCircle2 } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/config";

const HERO_IMG =
  "https://images.unsplash.com/photo-1753351052617-62818ffc9173?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGJ1c2luZXNzJTIwY2FmZSUyMG93bmVyfGVufDB8fHx8MTc4NDY5MTU4MHww&ixlib=rb-4.1.0&q=85";

const trustPoints = [
  "NZQBA & ICB member",
  "IRD compliant",
  "NZ-wide, fully remote",
];

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 overflow-hidden bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-16 items-center">
          {/* Left */}
          <div className="fade-up" style={{ animationDelay: "0.05s" }}>
            <span className="inline-block text-sm font-semibold tracking-[0.15em] uppercase text-[#0DA2AD] mb-5">
              Bookkeeping made simple · New Zealand
            </span>
            <h1 className="font-heading text-5xl sm:text-6xl font-bold tracking-tight leading-[1.05] text-[#10242B]">
              Stay Focused on Growth —{" "}
              <span className="text-[#10BFCB]">We'll Handle the Numbers</span>
            </h1>
            <p className="mt-7 text-lg leading-relaxed text-[#55636B] max-w-xl">
              Running a business is challenging — your books and admin don't
              need to be. Down-to-earth bookkeeping, payroll and GST support that
              keeps your finances organised, accurate and always up to date.
              Trusted by tradies and small businesses across NZ.
            </p>

            <div className="mt-9 flex flex-col sm:flex-row gap-4">
              <a
                href="#book"
                data-testid="hero-cta-button"
                className="inline-flex items-center justify-center gap-2 bg-[#E8791F] text-white font-semibold px-7 py-4 rounded-md hover:bg-[#CE6410] transition-colors"
              >
                Book a Free Consultation
                <ArrowRight size={18} />
              </a>
              <a
                href={`tel:${PHONE_TEL}`}
                data-testid="hero-phone-button"
                className="inline-flex items-center justify-center gap-2 bg-transparent text-[#10242B] border-2 border-[#10242B] font-semibold px-7 py-4 rounded-md hover:bg-[#10242B] hover:text-white transition-colors"
              >
                <Phone size={18} /> {PHONE_DISPLAY}
              </a>
            </div>

            <ul className="mt-9 flex flex-wrap gap-x-7 gap-y-3">
              {trustPoints.map((t) => (
                <li
                  key={t}
                  className="flex items-center gap-2 text-sm font-medium text-[#10242B]"
                >
                  <CheckCircle2 size={18} className="text-[#10BFCB]" />
                  {t}
                </li>
              ))}
            </ul>
          </div>

          {/* Right */}
          <div className="relative fade-up" style={{ animationDelay: "0.2s" }}>
            <div className="absolute -bottom-5 -right-5 w-full h-full rounded-md bg-[#10BFCB] hidden sm:block" />
            <img
              src={HERO_IMG}
              alt="Confident New Zealand small business owner"
              className="relative w-full h-[380px] lg:h-[520px] object-cover rounded-md border border-[#E1E8E9]"
              loading="eager"
            />
            <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur border border-[#E1E8E9] rounded-md px-5 py-4 shadow-sm">
              <p className="font-heading text-3xl font-bold text-[#10242B]">98%</p>
              <p className="text-xs font-medium text-[#55636B] uppercase tracking-wide">
                Client satisfaction
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
